export const createOrganizationAccount = `
    mutation createOrganizationAccount($input: CreateOrganizationAccountInput!) {
        createOrganizationAccount(input:$input) {
          id
          organizationId
          accountId
          account {
              id 
              email
          }
          organizationAccountStatus
    }
}`;

export const updateOrganizationAccount = `
    mutation updateOrganizationAccount($input: UpdateOrganizationAccountInput!) {
        updateOrganizationAccount(input:$input){
              id
              organizationId
              accountId
              account {
                  id 
                  email
              }
              organizationAccountStatus
        }
}`;

export const deactivateOrganizationAccount = `
    mutation deactivateOrganizationAccount($input: DeactivateOrganizationAccountInput!) {
        deactivateOrganizationAccount(input:$input) {
            id
            organizationId
            accountId
            organizationAccountStatus
        }
}`;
